import Event from '../../core/Event';
import { ArticleOrderDraft, ItemValidationResult } from '../../../domain/Order';

export default class OrderPlaceSucceed extends Event {
    public static type = 'OrderPlaceSucceed';

    constructor(public readonly articlesOrdersDrafts: ArticleOrderDraft[], public readonly itemValidationResult: ItemValidationResult[]) {
        super(OrderPlaceSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderPlaceSucceed.ts